// src/components/common/Toast.js

import React, { useEffect } from 'react';

const Toast = ({ message, type = 'success', onClose, duration = 4000 }) => {
  useEffect(() => {
    if (!message) return;
    const t = setTimeout(onClose, duration);
    return () => clearTimeout(t);
  }, [message, duration, onClose]);

  if (!message) return null;

  const styles = {
    success: { bg: '#1e7d4f', icon: '✓' },
    error:   { bg: '#c0392b', icon: '✕' },
    warning: { bg: '#d68910', icon: '⚠' },
    info:    { bg: '#1a6fa0', icon: 'ℹ' },
  };
  const s = styles[type] || styles.info;

  return (
    <div style={{
      position: 'fixed',
      bottom: '2rem',
      right: '2rem',
      zIndex: 9998,
      background: s.bg,
      color: '#fff',
      padding: '1rem 1.5rem',
      borderRadius: 'var(--radius-md)',
      boxShadow: 'var(--shadow-lg)',
      display: 'flex',
      alignItems: 'center',
      gap: '0.75rem',
      maxWidth: '380px',
      animation: 'slideIn 0.3s ease',
    }}>
      <span style={{ fontSize: '1.1rem', fontWeight: 700 }}>{s.icon}</span>
      <span style={{ flex: 1, fontSize: '0.9rem', lineHeight: 1.4 }}>{message}</span>
      <button
        onClick={onClose}
        style={{ background: 'transparent', border: 'none', color: 'rgba(255,255,255,0.7)', cursor: 'pointer', fontSize: '1rem', padding: '0 0.25rem' }}
      >
        ✕
      </button>
      <style>{`@keyframes slideIn { from { opacity:0; transform:translateX(20px); } to { opacity:1; transform:translateX(0); } }`}</style>
    </div>
  );
};

export default Toast;
